/**
 * Official AivoryEMS lockup (squircle mark + wordmark).
 * The PNG already includes “AivoryEMS”, so we do not render a second text label.
 */
export default function Logo({
  size = 36,
  showWordmark = true,
  compact = false,
  className = "",
  accent: _accent,
}) {
  // compact headers stay a bit smaller; full lockup needs room for the wordmark
  const px = compact ? Math.max(size, 32) : Math.max(size, 36);
  return (
    <img
      src="/aivory-ems-logo.png"
      alt="AivoryEMS"
      width={px}
      height={px}
      className={`shrink-0 rounded-[22%] object-contain ${className}`.trim()}
      style={{ width: px, height: px }}
      data-testid="aivory-logo"
      decoding="async"
    />
  );
}
